var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_380_27866)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1914 21.2685V8.06409H8.04443V26.5251H21.2432C21.513 24.8015 22.4941 23.2704 23.9474 22.3052C24.9111 21.6643 26.0347 21.3052 27.1914 21.2685Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5332 26.525C33.2417 24.5407 31.9994 22.8238 30.2058 21.9264V8.0641H42.5336C42.6974 8.0641 47.5694 7.02858 47.9722 13.2816V26.525H33.5332Z",
    fill: "#F919A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.04439 29.5391V42.5702C8.04439 42.7254 7.464 48 13.1763 48H27.1914V33.6779C24.618 33.625 22.3508 31.9726 21.5125 29.5391H8.04439Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_380_27866"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.9442,
    height: 40,
    fill: "white",
    transform: "translate(8.02783 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSign);
export default __webpack_public_path__ + "static/media/SIGN.2fc71bcee552440705b15959f921d1a3.svg";
export { ForwardRef as ReactComponent };